import React, { useContext, useEffect, useState } from 'react';
import { getLocalStorageItem, setLocalStorageItem } from '../common/utils';
const { createContext } = require("react");

const AdminSettingsContext = createContext();

export const useModuleSettings = () => useContext(AdminSettingsContext);

const AdminSettingsProvider = ({ children }) => {
    const defaultSettings = {
        filter: "all",
        search: "",
        page: 1,
        limit: 10
    };

    const [settings, setSettings] = useState(getLocalStorageItem("adminSettings", defaultSettings));

    useEffect(() => {
        setLocalStorageItem("adminSettings", settings);
    }, [settings]);

    const setFilter = (filter) => {
        setSettings((prev) => ({ ...prev, filter }));
    }

    const setSearch = (search) => {
        setSettings((prev) => ({ ...prev, search }));
    };

    const setPage = (page) => {
        setSettings((prev) => ({ ...prev, page }));
    };

    const setLimit = (limit) => {
        setSettings((prev) => ({ ...prev, limit }));
    };

    const resetSettings = () => {
        setSettings(defaultSettings);
    };

    return (
        <AdminSettingsContext.Provider value={{ ...settings, setFilter, setSearch, setPage, setLimit, resetSettings }}>
            {children}
        </AdminSettingsContext.Provider>
    )
}

export default AdminSettingsProvider;